import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { SharedStoreFacade } from 'app/main/shared/shared/store/shared-store.facade';
import { selectUserSetting } from 'app/store/reducers/user_settings.reducer';
import { environment } from 'environments/environment';
import { NgScrollbar } from 'ngx-scrollbar';
import Pusher from 'pusher-js';
import { delay, shareReplay } from 'rxjs';
import { ChatScopEnum } from '../../activity-logs/activity-form/activity-form.component';
import { RoleDetail } from '../../signing-page/signing-page.dto';
import { manupilateInternalChat } from './activity-helper';
import { TemplateDetails } from 'app/main/pages/documents/dto/document-details.dto';

@Component({
  selector: 'app-activity-logs',
  templateUrl: './activity-logs.component.html',
  styleUrl: './activity-logs.component.scss'
})
export class ActivityLogsComponent implements OnInit, OnDestroy {

  @ViewChild(NgScrollbar, { static: false }) scrollArea?: NgScrollbar;
  @ViewChild('scroll') scrollRef: ElementRef;
  
  @Input() hasViewAccess: boolean;
  @Input() roleId: number;
  @Input() document_id: number;
  @Input() is_sender: number;
  @Input() documentDetails$: TemplateDetails;
  @Input() roleDetail: RoleDetail | TemplateDetails;
  @Input() view: string = 'signingArea';
  public pusherRef: Pusher;

  constructor(private sharedFacade: SharedStoreFacade, private _store: Store) { }

  public activities$ = this.sharedFacade.activities$;
  public activitiesLoader$ = this.sharedFacade.activitiesLoader$;
  public userSettings$ = this._store.select(selectUserSetting);



  ngOnInit(): void {
    this.decideActivityRequest();
    this.activities$.pipe(
      delay(200),
        shareReplay()
      ).subscribe(() => this.scrollToBottom());
      this.getChats();
  }




  getChats(){
    // Pusher.logToConsole = true; // To Debug the pusher events
    this.pusherRef = new Pusher(environment.pusherAppKey, {
      cluster: environment.cluster
    });
    const channel = this.pusherRef.subscribe(environment.pusherChannel);
    channel.bind(`document-chat-${this.document_id}`, (data) => {
      if(this.view === 'signingArea' &&  data?.chatData?.scope === ChatScopEnum.Public){
        this.sharedFacade.updateMessage(manupilateInternalChat(data?.chatData));
      }
      else if(this.view === 'documentArea' || this.view === 'senderArea'){
        this.sharedFacade.updateMessage(manupilateInternalChat(data?.chatData));
      }
    });
  }




  decideActivityRequest(){
    return (this.view === 'documentArea' || this.view === 'senderArea')? this.loadDocumentActivity() : this.loadRecipientActivity();
  }



  /**
   * Load Document Activities 
   */
  loadDocumentActivity() {
      this.sharedFacade.fetchDocumentActivities(this.document_id);
  }



  /**
   * Load Recipient Activity
   */
  loadRecipientActivity(){
    this.sharedFacade.fetchRecipientActivties(this.roleId);
  }




  scrollToBottom() {
    if(this.scrollArea){
      this.scrollArea.scrollTo({bottom:0, duration: 300});
    }
  }


  ngOnDestroy(){
    this.pusherRef.unbind_all();
  }
}
